<template>
    <v-btn
        fab
        :small="!isCompassOpen"
        :large="isCompassOpen"
        @click.prevent="toggleCompassDisc()"
    >
        <div
            id="compass"
            class="compass"
            :class="{ 'compass-opened': isCompassOpen }"
            :style="{'height': compassHeight + 'px'}"
        >
            <img
                id="compass-img"
                class="compass-img"
            />
        </div>
    </v-btn>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'Compass',
        computed: {
            compassHeight() {
                return this.isCompassOpen ? 120 : 80;
            }
        },
        props: {
            widgetType: {
                type: String,
                required: true,
            },
            compassData: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            isCompassOpen: false
        }),
        methods: {
            toggleCompassDisc() {
                this.isCompassOpen = !this.isCompassOpen;
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_compass.scss";
</style>


// WEBPACK FOOTER //
// src/components/threeDController/components/Compass.vue